import React from 'react'
import { useParams } from 'react-router-dom';
import { blogs } from '../blogs';
import { BlogPageWrapper, BlogTitle, ReadTime, BlogSectionSpacer, BlogImage } from '../components/blog/blog.style';
import { ImportantWord } from '../components/about-page/about-page.styles';

const BlogPage = () => {
    const { blogId } = useParams();
    const blogInfo = blogs.find((blog) => blog.id === blogId)
    return (
        <BlogPageWrapper>
            <BlogImage src={blogInfo.image} />
            <BlogTitle>{blogInfo.title}</BlogTitle>
            <ReadTime style={{marginBottom: "20px"}}>
                {blogInfo.readtime} <ImportantWord style={{textTransform: "none"}}>minute</ImportantWord> read
            </ReadTime>
            <BlogSectionSpacer />
            {blogInfo.body}
        </BlogPageWrapper>
    )
}

export default BlogPage